/* eslint-disable no-restricted-syntax */

import Database from 'database';
import Helpers, { noRepeatingElements } from 'shared/helpers';
import { Queue } from 'models';
import api from 'api';
import moment from 'moment';
import { Creators as userCreators } from './user';

import { synchroniseTable, sendQueue } from 'shared/syncRoutines';

export const Types = {
  GET_QUEUE: 'queue/GET_QUEUE',
  GET_QUEUE_SUCCESS: 'queue/GET_QUEUE_SUCCESS',
  GET_QUEUE_FAILED: 'queue/GET_QUEUE_FAILED',
  ADD_QUEUE: 'pems/ADD_QUEUE',
  ADD_QUEUE_SUCCESS: 'pems/ADD_QUEUE_SUCCESS',
  ADD_QUEUE_FAILED: 'pems/ADD_QUEUE_FAILED',
  SET_SYNC_PROCESS: 'queue/SET_SYNC_PROCESS',
  PING: 'queue/PING',
  PING_FAILED: 'queue/PING_FAILED',
  PING_SUCCESS: 'queue/PING_SUCCESS',
  SYNC: 'queue/SYNC',
  SYNC_REGISTRY_UPDATE: 'queue/SYNC_UPDATE',
  SYNC_START: 'queue/SYNC_START',
  SYNC_REGISTRY_FINISH: 'queue/SYNC_REGISTRY_FINISH',
  SYNC_FAILED: 'queue/SYNC_FAILED',
  IN_SYNC: 'queue/IN_SYNC',
  BLOCK: 'queue/BLOCK',
  UNBLOCK: 'queue/UNBLOCK',
};

const initialState = {
  online: true,
  sending: false,
  error: null,
  data: [],
  loading: false,
  blocked: false,
  sync: {
    cidades: '0001-01-01',
    culturas: '0001-01-01',
    estados: '0001-01-01',
    impactos: '0001-01-01',
    pems: '0001-01-01',
    perguntas: '0001-01-01',
    produtos: '0001-01-01',
    respostas: '0001-01-01',
    etapas: '0001-01-01',
  },
};

export default function queueReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_QUEUE:
      return { ...state, loading: true };
    case Types.GET_QUEUE_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Types.GET_QUEUE_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.ADD_QUEUE:
      return { ...state, loading: true };
    case Types.ADD_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case Types.ADD_QUEUE_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.PING:
      return { ...state, sending: true };
    case Types.PING_SUCCESS:
      return {
        ...state,
        sending: false,
        online: true,
        error: null,
        loading: false,
        ...action.payload,
      };
    case Types.SYNC:
      return {
        ...state,
        online: true,
        sending: true,
        error: null,
        data: [],
        loading: false,
      };
    case Types.SYNC_REGISTRY_UPDATE:
      return {
        ...state,
        loading: true,
        sync: { ...state.sync, ...action.payload },
      };
    case Types.SYNC_REGISTRY_FINISH:
      return {
        ...state,
        sending: false,
        loading: false,
      };
    case Types.SYNC_FAILED:
      return {
        ...state,
        sending: false,
        loading: false,
        error: action.payload.error,
        data: action.payload.queue || state.data,
      };
    case Types.PING_FAILED:
      return {
        ...state,
        online: false,
        sending: false,
        loading: false,
        ...action.payload,
      };
    case Types.IN_SYNC:
      return {
        ...state,
        online: true,
        data: [],
        sending: false,
        error: null,
        loading: false,
        ...action.payload,
      };
    case Types.BLOCK:
      return { ...state, blocked: true };
    case Types.UNBLOCK:
      return { ...state, blocked: false };
    case Types.SYNC_START:
      return { ...state, loading: true };

    default:
      return state;
  }
}
export const Creators = {
  ping: (requested = false) => async (dispatch, state) => {
    if (state().queue.sending) {
      return;
    }
    dispatch({ type: Types.PING });
    const queue = await Database.queue.toArray();
    const syncs = (await Database.syncs.toArray()).map((s) => {
      delete s._id;
      return s;
    });
    syncs[0] = {
      ...state().queue.sync,
      ...(syncs[0] || {}),
    };
    const isSyncPending = Object.entries(syncs[0]).reduce((r, [, date]) => r || (date === '0001-01-01'), false);
    try {
      const { data } = await api.get('/sync');
      if (state().queue.blocked && !requested) {
        dispatch({ type: Types.PING_SUCCESS, payload: { sync: syncs[0] } });
        return;
      }
      dispatch({ type: Types.SYNC });
      const updatedTables = noRepeatingElements(
        queue.map((x) => x.table),
        (x, y) => x === y,
      );
      if (updatedTables.includes('pems')) {
        updatedTables.push('etapas', 'impactos', 'produtos');
      }
      if (queue.length > 0) {
        dispatch({
          type: Types.SYNC_START,
        });
      }
      // If should update (Happen when there was itens and all itens had been synchronized, 
      // false when there was an error on connection after retrying)
      // Or when there is no sync registered
      try {
        if ((await sendQueue(queue, dispatch)) || !syncs.length || isSyncPending) {
          dispatch({
            type: Types.SYNC_START,
          });
          await Helpers.asyncForEach(
            Object.entries(state().queue.sync),
            async ([localSyncTableName, lastSyncDate]) => {
              if (
                moment(data[localSyncTableName] || '9999-12-01').isAfter(
                  moment(lastSyncDate || '0001-01-01'),
                ) ||
                updatedTables.includes(localSyncTableName)
              ) {
                // There is no need to sync cities and states if they are already synched
                if (
                  ['cidades', 'estados'].includes(localSyncTableName) && (lastSyncDate !== '0001-01-01')
                ) return;
                await synchroniseTable(localSyncTableName, dispatch);
              }
            },
          );
          dispatch({ type: Types.SYNC_REGISTRY_FINISH });
        } else {
          dispatch({ type: Types.IN_SYNC, payload: { sync: syncs[0] } });
        }
      } catch (e) {
        dispatch({
          type: Types.SYNC_FAILED,
          payload: {
            error: 'sync_failed',
            queue: e.queue,
          },
        });
      }
    } catch (oof) {
      if (
        oof.response &&
        oof.response.data &&
        (oof.response.data.error === 'token_invalid' ||
          oof.response.data.error === 'token_expired')
      ) {
        dispatch(userCreators.expire());
      }
      dispatch({
        type: Types.PING_FAILED,
        payload: {
          data: queue,
          sync: syncs[0],
        },
      });
    }
  },
  getQueue: () => async (dispatch) => {
    try {
      dispatch({ type: Types.GET_QUEUE });
      const queue = await Database.queue.toArray();
      dispatch({
        type: Types.GET_QUEUE_SUCCESS,
        payload: { data: queue },
      });
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.GET_QUEUE_FAILED,
        payload: { error: woof.message },
      });
    }
  },
  addToQueue: (data) => async (dispatch) => {
    try {
      dispatch({ type: Types.ADD_QUEUE });
      const queue = new Queue({
        table: data.table,
        localId: data.localId,
        requestBody: data.requestBody,
      });
      await queue.save();
      data = queue;
      dispatch({ type: Types.ADD_QUEUE_SUCCESS });
      dispatch(Creators.getQueue());
    } catch (woof) {
      dispatch({
        type: Types.ADD_QUEUE_FAILED,
        payload: { error: woof.message },
      });
    }
  },
  lock: () => async (dispatch) => {
    dispatch({ type: Types.BLOCK });
  },
  unlock: () => async (dispatch) => {
    dispatch({ type: Types.UNBLOCK });
  },
};
